import { useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import EditDepotModal from "./EditDepotModal";

const ActionsCell = ({ params, setOpenDeleteDepot, setSelectedDepot, setRefreshList }) => {

  // console.log("params test Actions", params)
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedEditDepot, setSelectedEditDepot] = useState(null);

  const handleEditClick = () => {
    setSelectedEditDepot(params.row);
    setOpenEditModal(true);
  };

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setSelectedEditDepot(null);
  };

  const handleEditSuccess = () => {
    handleCloseEditModal();
    setRefreshList(true); // This will trigger the table to refresh
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 1,
          height: "100%",
        }}
      >

        {params.row.allow_edit === 1 && (

        
        <Tooltip title="Edit">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              backgroundColor: "#FAFAFA",
              borderRadius: "6px",
              border: "1px solid #E0E0E0",
              padding: "4px 8px",
              gap: 1,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#E8F5E9",
                borderColor: "#4EB052",
              },
            }}
            onClick={handleEditClick}
          >
            <EditIcon sx={{ fontSize: 18, color: "#4EB052" }} />
            <Typography
              variant="body2"
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#4EB052",
              }}
            >
              Edit
            </Typography>
          </Box>
        </Tooltip>
        )}

{
  params.row.allow_delete === 1 && (

       <Tooltip title="Delete">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              backgroundColor: "#FAFAFA",
              borderRadius: "6px",
              border: "1px solid #E0E0E0",
              padding: "4px 8px",
              gap: 1,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#FFEBEE",
                borderColor: "#FFCDD2",
              },
            }}
            onClick={() => {
              setSelectedDepot(params.row);
              setOpenDeleteDepot(true);
            }}
          >
            <DeleteIcon sx={{ fontSize: 18, color: "#d32f2f" }} />
            <Typography
              variant="body2"
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#d32f2f",
              }}
            >
              Delete
            </Typography>

          </Box>
        </Tooltip>
         )
}
  
      </Box>

      <EditDepotModal
        open={openEditModal}
        onClose={handleCloseEditModal}
        depotData={selectedEditDepot}
        onSuccess={handleEditSuccess}
      />
    </>
  );
};

export default ActionsCell;